import { useEffect, useState } from 'react';

export function useIsMacOs(): boolean {
  const [isMac, setIsMac] = useState(false);
  useEffect(() => {
    setIsMac(
      /Mac|iPhone|iPad|iPod/.test(navigator.platform) ||
      /\bMac OS\b/.test(navigator.userAgent)
    );
  }, []);
  return isMac;
}
